import { Component, OnInit, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { NewsletterSection, NewsletterInfo, NewsletterSectionResponseModel, NewsletterEditViewModelV2, IsCompliantModel } from '../../../../models/catalogue-view.model';
import { ApiResponse } from '../../../../models/api-response.model';
import { Subject, Subscription } from '../../../../../../node_modules/rxjs';
import { NewsletterEditProductComponent } from '../../../../popup-collection/newsletter-edit-product/newsletter-edit-product.component';
import { NewsletterEditUrlComponent } from '../../../../popup-collection/newsletter-edit-url/newsletter-edit-url.component';
import { NewsletterEditHeadingComponent } from '../../../../popup-collection/newsletter-edit-heading/newsletter-edit-heading.component';
import { NewsletterEditCommentComponent } from '../../../../popup-collection/newsletter-edit-comment/newsletter-edit-comment.component';
import { CommonService } from '../../../../services';
import { MatDialog } from '@angular/material/dialog';
import { NgProgressService } from '../../../../services/ngProgress.service';
import { NewsletterService } from '../../../../services/newsletter.service';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { switchMap, takeUntil } from 'rxjs/operators';
import { NewsletterDeleteSectionComponent } from '../../../../popup-collection/newsletter-delete-section/newsletter-delete-section.component';
@Component({
  selector: 'app-newsletter-section-block-v2',
  templateUrl: './newsletter-section-block-v2.component.html',
  styleUrls: ['./newsletter-section-block-v2.component.css']
})
export class NewsletterSectionBlockV2Component implements OnInit {

  blockWatchSubscription: Subscription;

  newsletterSectionBlocks: NewsletterSection[];
  newsletterSectionBlock: NewsletterSection;

  nl_content: string = "";
  nl_description: string = "";
  nl_url: string = "";
  nl_area: string = "";
  editBlock: boolean = false;

  dragDropModel: NewsletterSection;
  targetSectionId: string;
  targetSectionIdArray: string[] = [];
  targetPromo: NewsletterSection;
  targetPos: string;
  dragIndex: number;
  targetIndex: number;
  moveIndex: number;
  movePromo: NewsletterSection;
  tempMovePromo: NewsletterSection;
  movePos: string;

  @Input() newsletterInfo: NewsletterInfo;
  @Input() sendSectionToBlock: NewsletterSection;
  @Output() editBlockEvent = new EventEmitter<boolean>();
  @Output() loadingTitleEvent = new EventEmitter<{newsId:string,title:string} | null>();
  @Input() newsletterEditViewModel: NewsletterEditViewModelV2;


  ngUnsubscribe: Subject<void> = new Subject<void>();
  changeNewsLetterType$: Subject<{ id: any, published: any }> = new Subject<{ id: any, published: any }>();


  constructor(
    private newsletterService: NewsletterService,
    private ngProgress: NgProgressService,
    private dialog: MatDialog,
    private commonService: CommonService
  ) { }

  ngOnInit() {

    this.blockWatchSubscription = this.newsletterService.currentBlockWatch.subscribe((data: NewsletterSectionResponseModel) => {
      if(data.section_pid == this.sendSectionToBlock.section_id) {
        this.newsletterService.getNewsletterInfo(this.sendSectionToBlock.news_id)
      .subscribe((res: NewsletterInfo) => {
        this.newsletterInfo = res;
        this.loadSectionBlock();
      },
        (error: any) => {
          console.error(error);
          this.ngProgress.done();
        });
      }

    },
      (error: any) => {
        console.info(error);
        this.ngProgress.done();
      });
      this.loadSectionBlock();


      this.changeNewsLetterType$.asObservable().pipe(
        switchMap((newsletter) => {
            return this.newsletterService.updateNewsletterPublishSQL(newsletter.id, newsletter.published)
        })
    ).pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => {
      this.newsletterService.monitorEditNewsletterInfoChange(this.newsletterEditViewModel);
    });
  }

  loadSectionBlock() {
    this.ngProgress.start();
    this.newsletterSectionBlocks = this.newsletterInfo.sectionList.filter(x => x.section_type != "nl_section" && x.section_type && x.section_pid == this.sendSectionToBlock.section_id);
    this.newsletterSectionBlocks.map((value, key) => {
      if (value.section_type == "products") {
        this.newsletterService.getProducts(this.sendSectionToBlock.news_id, value.section_id).subscribe((response: NewsletterSectionResponseModel) => {
          value.product_list = response.product_list;
          value.stock_codes = response.stockCode;
        });
      }
    });
    this.ngProgress.done();
  }

  onDropCDKBlock(event: CdkDragDrop<string[]>): void {

    if (event.previousIndex != event.currentIndex) {
      this.ngProgress.start();

      const nlSecBup = [ ...this.newsletterSectionBlocks ];
      const dragData = { ...this.newsletterSectionBlocks[event.previousIndex] };
      const targetData = { ...this.newsletterSectionBlocks[event.currentIndex] };

      if (event.previousIndex -1 > event.currentIndex) {
        for (var i = event.previousIndex; i >= event.currentIndex; i--) {
          this.newsletterSectionBlocks[i].section_pos = (this.commonService.toNumber(this.newsletterSectionBlocks[i].section_pos) + 1).toString();
        }
      }
      else{
        for (var i = event.previousIndex + 1; i <= event.currentIndex; i++) {
          this.newsletterSectionBlocks[i].section_pos = (this.commonService.toNumber(this.newsletterSectionBlocks[i].section_pos) - 1).toString();
        }
      }
      this.newsletterSectionBlocks.splice(event.previousIndex, 1);
      dragData.section_pos = targetData.section_pos;
      this.newsletterSectionBlocks.splice(event.currentIndex, 0, dragData);
      
      
      switch (dragData.section_type) {
        case "products":
          this.newsletterService.saveProducts(dragData).subscribe((res: NewsletterSectionResponseModel) => {
            if (res && res.status) {
              this.commonService.implementToast("Successfully save product", "Success");
              this.ngProgress.done();
            }
          }),
            (error: any) => {
              console.error(error);
              this.newsletterSectionBlocks = nlSecBup;
              this.ngProgress.done();
            }
          break;
        case "link":
          this.newsletterService.saveLink(dragData).subscribe((res: NewsletterSectionResponseModel) => {
            if (res && res.status) {
              this.commonService.implementToast("Successfully save link", "Success");
              this.ngProgress.done();
            }
          }),
            (error: any) => {
              console.error(error);
              this.newsletterSectionBlocks = nlSecBup;
              this.ngProgress.done();
            }
          break;
        case "nl_comment":
          this.newsletterService.saveBlock(dragData).subscribe((res: NewsletterSectionResponseModel) => {
            if (res && res.status) {
              this.commonService.implementToast("Successfully save comment", "Success");
              this.ngProgress.done();
            }
          }),
            (error: any) => {
              console.error(error);
              this.newsletterSectionBlocks = nlSecBup;
              this.ngProgress.done();
            }
          break;
        case "nl_heading":
          this.newsletterService.saveBlock(dragData).subscribe((res: NewsletterSectionResponseModel) => {
            if (res && res.status) {
              this.commonService.implementToast("Successfully save heading", "Success");
              this.ngProgress.done();
            }
          }),
            (error: any) => {
              console.error(error);
              this.newsletterSectionBlocks = nlSecBup;
              this.ngProgress.done();
            }
          break;
      }
    }
  }

  moveUp(section: NewsletterSection): void {
    debugger;
    this.moveIndex = this.newsletterSectionBlocks.findIndex(x => x.section_id == section.section_id);
    if (this.moveIndex != 0) {
      this.ngProgress.start();

      const nlSecBup = [ ...this.newsletterSectionBlocks ];
      const movePromo = { ...this.newsletterSectionBlocks[this.moveIndex] };
      const targetPromo = { ...this.newsletterSectionBlocks[this.moveIndex - 1] };

      this.newsletterSectionBlocks[this.moveIndex] = { ...targetPromo };
      this.newsletterSectionBlocks[this.moveIndex].section_pos = movePromo.section_pos;
      this.newsletterSectionBlocks[this.moveIndex - 1] = { ...movePromo };
      this.newsletterSectionBlocks[this.moveIndex - 1].section_pos = targetPromo.section_pos;
      this.movePromo = this.newsletterSectionBlocks[this.moveIndex - 1];


      // this.movePromo = this.newsletterSectionBlocks[this.moveIndex];
      // this.targetPromo = this.newsletterSectionBlocks[this.moveIndex - 1];
      // this.movePos = this.newsletterSectionBlocks[this.moveIndex].section_pos;
      // this.targetPos = this.newsletterSectionBlocks[this.moveIndex - 1].section_pos;
      // this.newsletterSectionBlocks[this.moveIndex] = this.targetPromo;
      // this.newsletterSectionBlocks[this.moveIndex].section_pos = this.targetPos;
      // this.newsletterSectionBlocks[this.moveIndex - 1] = this.movePromo;
      // this.newsletterSectionBlocks[this.moveIndex - 1].section_pos = this.movePos;
      // this.movePromo.section_pos = (toNumber(this.targetPromo.section_pos) - 1).toString();
      switch (this.movePromo.section_type) {
        case "products":
          this.newsletterService.saveProducts(this.movePromo).subscribe((res: NewsletterSectionResponseModel) => {
            if (res && res.status) {
              this.commonService.implementToast("Successfully save product", "Success");
              this.ngProgress.done();
            }
          }),
            (error: any) => {
              console.error(error);
              this.newsletterSectionBlocks = nlSecBup;
              this.ngProgress.done();
            }
          break;
        case "link":
          this.newsletterService.saveLink(this.movePromo).subscribe((res: NewsletterSectionResponseModel) => {
            if (res && res.status) {
              this.commonService.implementToast("Successfully save link", "Success");
              this.ngProgress.done();
            }
          }),
            (error: any) => {
              console.error(error);
              this.newsletterSectionBlocks = nlSecBup;
              this.ngProgress.done();
            }
          break;
        case "nl_comment":
          this.newsletterService.saveBlock(this.movePromo).subscribe((res: NewsletterSectionResponseModel) => {
            if (res && res.status) {
              this.commonService.implementToast("Successfully save comment", "Success");
              this.ngProgress.done();
            }
          }),
            (error: any) => {
              console.error(error);
              this.newsletterSectionBlocks = nlSecBup;
              this.ngProgress.done();
            }
          break;
        case "nl_heading":
          this.newsletterService.saveBlock(this.movePromo).subscribe((res: NewsletterSectionResponseModel) => {
            if (res && res.status) {
              this.commonService.implementToast("Successfully save heading", "Success");
              this.ngProgress.done();
            }
          }),
            (error: any) => {
              console.error(error);
              this.newsletterSectionBlocks = nlSecBup;
              this.ngProgress.done();
            }
          break;
      }

      this.ngProgress.done();
    }
  }

  moveDown(section: NewsletterSection): void {

    this.moveIndex = this.newsletterSectionBlocks.findIndex(x => x.section_id == section.section_id);

    if (this.moveIndex != this.newsletterSectionBlocks.length - 1) {
      this.ngProgress.start();

      const nlSecBup = [ ...this.newsletterSectionBlocks ];
      const movePromo = { ...this.newsletterSectionBlocks[this.moveIndex] };
      const targetPromo = { ...this.newsletterSectionBlocks[this.moveIndex + 1] };

      this.newsletterSectionBlocks[this.moveIndex] = { ...targetPromo };
      this.newsletterSectionBlocks[this.moveIndex].section_pos = movePromo.section_pos;
      this.newsletterSectionBlocks[this.moveIndex + 1] = { ...movePromo };
      this.newsletterSectionBlocks[this.moveIndex + 1].section_pos = targetPromo.section_pos;
      this.movePromo = this.newsletterSectionBlocks[this.moveIndex + 1];


      // this.movePromo = this.newsletterSectionBlocks[this.moveIndex];
      // this.targetPromo = this.newsletterSectionBlocks[this.moveIndex + 1];
      // this.movePos = this.newsletterSectionBlocks[this.moveIndex].section_pos;
      // this.targetPos = this.newsletterSectionBlocks[this.moveIndex + 1].section_pos;
      // this.newsletterSectionBlocks[this.moveIndex] = this.targetPromo;
      // this.newsletterSectionBlocks[this.moveIndex].section_pos = this.targetPos;
      // this.newsletterSectionBlocks[this.moveIndex + 1] = this.movePromo;
      // this.newsletterSectionBlocks[this.moveIndex + 1].section_pos = this.movePos;
      // this.movePromo.section_pos = (toNumber(this.targetPromo.section_pos) + 1).toString();

      switch (this.movePromo.section_type) {
        case "products":
          this.newsletterService.saveProducts(this.movePromo).subscribe((res: NewsletterSectionResponseModel) => {
            if (res && res.status) {
              this.commonService.implementToast("Successfully save product", "Success");
              this.ngProgress.done();
            }
          }),
            (error: any) => {
              console.error(error);
              this.newsletterSectionBlocks = nlSecBup;
              this.ngProgress.done();
            }
          break;
        case "link":
          this.newsletterService.saveLink(this.movePromo).subscribe((res: NewsletterSectionResponseModel) => {
            if (res && res.status) {
              this.commonService.implementToast("Successfully save link", "Success");
              this.ngProgress.done();
            }
          }),
            (error: any) => {
              console.error(error);
              this.newsletterSectionBlocks = nlSecBup;
              this.ngProgress.done();
            }
          break;
        case "nl_comment":
          this.newsletterService.saveBlock(this.movePromo).subscribe((res: NewsletterSectionResponseModel) => {
            if (res && res.status) {
              this.commonService.implementToast("Successfully save comment", "Success");
              this.ngProgress.done();
            }
          }),
            (error: any) => {
              console.error(error);
              this.newsletterSectionBlocks = nlSecBup;
              this.ngProgress.done();
            }
          break;
        case "nl_heading":
          this.newsletterService.saveBlock(this.movePromo).subscribe((res: NewsletterSectionResponseModel) => {
            if (res && res.status) {
              this.commonService.implementToast("Successfully save heading", "Success");
              this.ngProgress.done();
            }
          }),
            (error: any) => {
              console.error(error);
              this.newsletterSectionBlocks = nlSecBup;
              this.ngProgress.done();
            }
          break;
      }

      this.ngProgress.done();
    }
  }

  deleteBlock(block: NewsletterSection): void {  
    var sectionType = '';
    switch (block.section_type) {
      case "products":
        sectionType = 'product section';
        break;
      case "link":
        sectionType = 'link';
        break;
      case "nl_comment":
        sectionType = 'comment';
        break;
      case "nl_heading":
        sectionType = 'heading';
        break;
    }
    
    const dialogRef = this.dialog.open(NewsletterDeleteSectionComponent, {
      width: '500px',
      panelClass: 'mat-dialog-wrapper',
      data: { type: sectionType }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.ngProgress.start();

        switch (block.section_type) {
          case "products":
            this.loadingTitleEvent.emit({newsId:block.section_pid,title:"Deleting product list..."});
            this.newsletterService.deleteProducts(block.news_id, block.section_id).subscribe((res: ApiResponse) => {
              this.newsletterService.getNewsletterInfo(this.sendSectionToBlock.news_id).subscribe((res: NewsletterInfo) => {
                this.newsletterSectionBlocks = res.sectionList.filter(x => x.section_type != "nl_section" && x.section_type && x.section_pid == this.sendSectionToBlock.section_id);
                this.newsletterSectionBlocks.map((value, key) => {
                  if (value.section_type == "products") {
                    this.newsletterService.getProducts(this.sendSectionToBlock.news_id, value.section_id).subscribe((response: NewsletterSectionResponseModel) => {
                      value.product_list = response.product_list;
                      value.stock_codes = response.stockCode;
                    });
                  }
                });
                this.loadingTitleEvent.emit(null);
                this.ngProgress.done();
              },
                (error: any) => {
                  console.info(error);
                  this.loadingTitleEvent.emit(null);
                  this.ngProgress.done();
                });
            },
              (error: any) => {
                console.info(error);
                this.loadingTitleEvent.emit(null);
                this.ngProgress.done();
              });
            break;
          case "link":
            this.loadingTitleEvent.emit({newsId:block.section_pid,title:"Deleting link..."});
            this.newsletterService.deleteLink(block.news_id, block.section_id).subscribe((res: ApiResponse) => {
              this.newsletterService.getNewsletterInfo(this.sendSectionToBlock.news_id).subscribe((res: NewsletterInfo) => {
                this.newsletterSectionBlocks = res.sectionList.filter(x => x.section_type != "nl_section" && x.section_type && x.section_pid == this.sendSectionToBlock.section_id);
                this.newsletterSectionBlocks.map((value, key) => {
                  if (value.section_type == "products") {
                    this.newsletterService.getProducts(this.sendSectionToBlock.news_id, value.section_id).subscribe((response: NewsletterSectionResponseModel) => {
                      value.product_list = response.product_list;
                      value.stock_codes = response.stockCode;
                    });
                  }
                });
                this.loadingTitleEvent.emit(null);
                this.ngProgress.done();
              },
                (error: any) => {
                  console.info(error);
                  this.loadingTitleEvent.emit(null);
                  this.ngProgress.done();
                });
            },
              (error: any) => {
                console.info(error);
                this.loadingTitleEvent.emit(null);
                this.ngProgress.done();
              });
            break;
          case "nl_comment":
            this.loadingTitleEvent.emit({newsId:block.section_pid,title:"Deleting comment..."});
            this.newsletterService.deleteSection(block.news_id, block.section_id).subscribe((res: ApiResponse) => {
              this.newsletterService.getNewsletterInfo(this.sendSectionToBlock.news_id).subscribe((res: NewsletterInfo) => {
                this.newsletterSectionBlocks = res.sectionList.filter(x => x.section_type != "nl_section" && x.section_type && x.section_pid == this.sendSectionToBlock.section_id);
                this.newsletterSectionBlocks.map((value, key) => {
                  if (value.section_type == "products") {
                    this.newsletterService.getProducts(this.sendSectionToBlock.news_id, value.section_id).subscribe((response: NewsletterSectionResponseModel) => {
                      value.product_list = response.product_list;
                      value.stock_codes = response.stockCode;
                    });
                  }
                });
                this.loadingTitleEvent.emit(null);
                this.ngProgress.done();
              },
                (error: any) => {
                  console.info(error);
                  this.loadingTitleEvent.emit(null);
                  this.ngProgress.done();
                });
            },
              (error: any) => {
                console.info(error);
                this.loadingTitleEvent.emit(null);
                this.ngProgress.done();
              });
            break;
          case "nl_heading":
            this.loadingTitleEvent.emit({newsId:block.section_pid,title:"Deleting heading..."});
            this.newsletterService.deleteSection(block.news_id, block.section_id).subscribe((res: ApiResponse) => {
              this.newsletterService.getNewsletterInfo(this.sendSectionToBlock.news_id).subscribe((res: NewsletterInfo) => {
                this.newsletterSectionBlocks = res.sectionList.filter(x => x.section_type != "nl_section" && x.section_type && x.section_pid == this.sendSectionToBlock.section_id);
                this.newsletterSectionBlocks.map((value, key) => {
                  if (value.section_type == "products") {
                    this.newsletterService.getProducts(this.sendSectionToBlock.news_id, value.section_id).subscribe((response: NewsletterSectionResponseModel) => {
                      value.product_list = response.product_list;
                      value.stock_codes = response.stockCode;
                    });
                  }
                });
                this.loadingTitleEvent.emit(null);
                this.ngProgress.done();
              },
                (error: any) => {
                  console.info(error);
                  this.loadingTitleEvent.emit(null);
                  this.ngProgress.done();
                });
            },
              (error: any) => {
                console.info(error);
                this.loadingTitleEvent.emit(null);
                this.ngProgress.done();
              });
            break;
        }
	  }
    });
    
  }

  editHeading(block: NewsletterSection): void {
    const dialogRef = this.dialog.open(NewsletterEditHeadingComponent, {
      width: '500px',
      data: { block: block },
      panelClass: 'mat-dialog-wrapper'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.ngProgress.start();
        this.loadingTitleEvent.emit({newsId:block.section_pid,title:"Saving heading..."});
        result.block.content = encodeURIComponent(result.block.content.toUpperCase());
        this.newsletterService.saveBlock(result.block).subscribe((data: NewsletterSectionResponseModel) => {
          this.newsletterService.getNewsletterInfo(this.sendSectionToBlock.news_id).subscribe((res: NewsletterInfo) => {
            this.newsletterSectionBlocks = res.sectionList.filter(x => x.section_type != "nl_section" && x.section_type && x.section_pid == this.sendSectionToBlock.section_id);
            this.newsletterSectionBlocks.map((value, key) => {
              if (value.section_type == "products") {
                this.newsletterService.getProducts(this.sendSectionToBlock.news_id, value.section_id).subscribe((response: NewsletterSectionResponseModel) => {
                  value.product_list = response.product_list;
                  value.stock_codes = response.stockCode;
                });
              }
            });
            this.loadingTitleEvent.emit(null);
            this.ngProgress.done();
          },
            (error: any) => {
              console.info(error);
              this.loadingTitleEvent.emit(null);
              this.ngProgress.done();
            });
        },
          (error: any) => {
            console.info(error);
            this.loadingTitleEvent.emit(null);
            this.ngProgress.done();
          });
      }
    });
  }

  editComment(block: NewsletterSection): void {
    const dialogRef = this.dialog.open(NewsletterEditCommentComponent, {
      width: '500px',
      data: { block: block },
      panelClass: 'mat-dialog-wrapper'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.ngProgress.start();
        this.loadingTitleEvent.emit({newsId:block.section_pid,title:"Saving comment..."});
        result.block.content = encodeURIComponent(result.block.content);
        this.newsletterService.saveBlock(result.block).subscribe((data: NewsletterSectionResponseModel) => {
          this.newsletterService.getNewsletterInfo(this.sendSectionToBlock.news_id).subscribe((res: NewsletterInfo) => {
            this.newsletterSectionBlocks = res.sectionList.filter(x => x.section_type != "nl_section" && x.section_type && x.section_pid == this.sendSectionToBlock.section_id);
            this.newsletterSectionBlocks.map((value, key) => {
              if (value.section_type == "products") {
                this.newsletterService.getProducts(this.sendSectionToBlock.news_id, value.section_id).subscribe((response: NewsletterSectionResponseModel) => {
                  value.product_list = response.product_list;
                  value.stock_codes = response.stockCode;
                });
              }
            });
            this.loadingTitleEvent.emit(null);
            this.ngProgress.done();
          },
            (error: any) => {
              console.info(error);
              this.loadingTitleEvent.emit(null);
              this.ngProgress.done();
            });
        },
          (error: any) => {
            console.info(error);
            this.loadingTitleEvent.emit(null);
            this.ngProgress.done();
          });
      }
    });
  }

  editUrl(block: NewsletterSection): void {
    const dialogRef = this.dialog.open(NewsletterEditUrlComponent, {
      width: '500px',
      data: { block: block },
      panelClass: 'mat-dialog-wrapper'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.ngProgress.start();
        this.loadingTitleEvent.emit({newsId:block.section_pid,title:"Saving link..."});
        this.newsletterService.saveLink(result.block).subscribe((data: NewsletterSectionResponseModel) => {
          this.newsletterService.getNewsletterInfo(this.sendSectionToBlock.news_id).subscribe((res: NewsletterInfo) => {
            this.newsletterSectionBlocks = res.sectionList.filter(x => x.section_type != "nl_section" && x.section_type && x.section_pid == this.sendSectionToBlock.section_id);
            this.newsletterSectionBlocks.map((value, key) => {
              if (value.section_type == "products") {
                this.newsletterService.getProducts(this.sendSectionToBlock.news_id, value.section_id).subscribe((response: NewsletterSectionResponseModel) => {
                  value.product_list = response.product_list;
                  value.stock_codes = response.stockCode;
                });
              }
            });
            this.loadingTitleEvent.emit(null);
            this.ngProgress.done();
          },
            (error: any) => {
              console.info(error);
              this.loadingTitleEvent.emit(null);
              this.ngProgress.done();
            });
        },
          (error: any) => {
            console.info(error);
            this.loadingTitleEvent.emit(null);
            this.ngProgress.done();
          });
      }
    });
  }

  editProductList(block: NewsletterSection): void {
    const dialogRef = this.dialog.open(NewsletterEditProductComponent, {
      width: '500px',
      data: { block: block },
      panelClass: 'mat-dialog-wrapper'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.ngProgress.start();
        this.loadingTitleEvent.emit({newsId:block.section_pid,title:"Saving product list..."});
        this.newsletterService.saveProducts(result.block).subscribe((data: NewsletterSectionResponseModel) => {
          this.newsletterService.containsRestrictedStock(this.sendSectionToBlock.news_id).subscribe((res: boolean) => {
              if (res == true && !this.newsletterEditViewModel.license) {
                this.commonService.implementToast('Current newsletter contains restricted items but does not have a license applied. Does this newsletter require a license?','Error');
              }
            },
            (error: any) => {
              console.info(error);
              this.loadingTitleEvent.emit(null);
              this.ngProgress.done();
          });

          this.newsletterService.isNewsletterCompliant(this.sendSectionToBlock.news_id).subscribe((res: IsCompliantModel) => {
            if (res.isCompliant == true) {
              // do nothing
            } else  {
              if (this.newsletterInfo.published == '0') {
                this.commonService.implementToast('Please be advised this newsletter has been unpublished as is does not meet the minimum requirements to be published. ' + res.errorMessage , 'Error');
                this.changeNewsLetterType$.next({ id: this.sendSectionToBlock.news_id, published: '1'});
            }
          }},
          (error: any) => {
            console.info(error);
            this.loadingTitleEvent.emit(null);
            this.ngProgress.done();
          });

          this.newsletterService.getSections(this.sendSectionToBlock.news_id).subscribe((res: NewsletterInfo) => {
              this.newsletterInfo = res;
              this.loadSectionBlock();
              this.loadingTitleEvent.emit(null);
            },
              (error: any) => {
                console.info(error);
                this.loadingTitleEvent.emit(null);
                this.ngProgress.done();
              });
        },
          (error: any) => {
            console.info(error);
            this.loadingTitleEvent.emit(null);
            this.ngProgress.done();
          });
      }
    });
  }


  ngOnDestroy() {
    if (this.blockWatchSubscription) {
      this.blockWatchSubscription.unsubscribe();
    }
  }

}
